/** Clé de regroupement = une semaine / date d'envoi (semaine_date API). */
export function getPlanningWeekKey(vente) {
  if (vente?.semaine_date) {
    return vente.semaine_date;
  }

  return `${vente?.annee ?? ''}|${vente?.mois ?? ''}|${vente?.semaine ?? ''}`;
}

/** Index de couleur (0 ou 1) par ligne, alterné à chaque changement de semaine. */
export function buildPlanningWeekColorByRowId(ventes, getRowId) {
  const map = new Map();
  let colorIndex = 0;
  let lastKey = null;

  for (const vente of ventes ?? []) {
    const key = getPlanningWeekKey(vente);
    if (lastKey !== null && key !== lastKey) {
      colorIndex = colorIndex === 0 ? 1 : 0;
    }
    lastKey = key;
    map.set(getRowId(vente), colorIndex);
  }

  return map;
}
